import { render, staticRenderFns } from "./MintActionCard.vue?vue&type=template&id=0040bf52&"
import script from "./MintActionCard.vue?vue&type=script&lang=js&"
export * from "./MintActionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports